// Public support page rendered at /support. No auth required.
import { useEffect } from 'react'

export default function SupportPage({ onNavigate }) {
  useEffect(() => {
    const prev = document.title
    document.title = 'Support · The Bible Community'
    return () => { document.title = prev }
  }, [])

  function goBack(e) {
    e?.preventDefault?.()
    if (onNavigate) onNavigate('/')
    else if (typeof window !== 'undefined') window.location.href = '/'
  }

  function goPrivacy(e) {
    e?.preventDefault?.()
    if (onNavigate) onNavigate('/privacy')
    else if (typeof window !== 'undefined') window.location.href = '/privacy'
  }

  return (
    <div style={S.shell}>
      <div style={S.bar}>
        <a href="/" onClick={goBack} style={S.back}>← Back</a>
        <div style={S.brand}>The Bible Community</div>
      </div>

      <article style={S.article}>
        <h1 style={S.h1}>Support</h1>
        <p style={S.lead}>
          If you have any support queries please contact us at{' '}
          <a href="mailto:hello@thebiblecommunity.co.uk" style={S.a}>hello@thebiblecommunity.co.uk</a>.
          You can find our privacy policy{' '}
          <a href="/privacy" style={S.a} onClick={goPrivacy}>here</a>.
        </p>
      </article>
    </div>
  )
}

const S = {
  shell:   { minHeight: '100vh', background: 'var(--cream)', color: 'var(--ink)', fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" },
  bar:     { position: 'sticky', top: 0, zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', borderBottom: '1px solid var(--border)', background: 'rgba(246,242,236,0.92)', backdropFilter: 'blur(8px)' },
  back:    { color: 'var(--gold-ink)', fontSize: 13, textDecoration: 'none', fontWeight: 700, letterSpacing: '0.04em' },
  brand:   { fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: 12, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--gold-ink)' },
  article: { maxWidth: 720, margin: '0 auto', padding: '40px 24px 80px' },
  h1:      { fontFamily: "'Source Serif 4', Georgia, serif", fontSize: 'clamp(32px, 6vw, 44px)', lineHeight: 1.1, marginBottom: 14 },
  lead:    { fontSize: 16, lineHeight: 1.7, color: 'var(--ink)' },
  a:       { color: 'var(--gold-ink)', textDecoration: 'underline' },
}
